import moment from 'moment';
import { createDateObject, newUUID, statuses } from '@/core';

export default function() {
	return {
		id: newUUID(),
		prev: null,
		next: null,
		orderId: undefined,
		orderNumber: undefined,
		accepted: false,
		additionalReferences: [],
		etd: createDateObject({ hasTime: false }),
		atd: emptyDate(),
		eta: createDateObject({ hasTime: false }),
		ata: emptyDate(),
		chargableWeight: 0,
		clerk: undefined,
		consignee: address(),
		consigneeReference: undefined,
		consignor: address(),
		createdAt: moment.utc().valueOf(),
		customer: {
			...address(),
			customerNo: undefined
		},
		customersReference: undefined,
		deliveryOption: 'deliveryParty',
		deliveryParty: address(),
		despatchOption: 'despatchParty',
		despatchParty: address(),
		deviations: [],
		finalDeliveryParty: address(),
		invoiceFreeText: undefined,
		loadingListFreeText: undefined,
		goodsListFreeText: undefined,
		transporterInstructions: undefined,
		freightLines: [],
		goodsType: undefined,
		grossWeight: 0,
		internalNotes: undefined,
		loadingMeters: 0,
		loadingSequenceNo: undefined,
		mayGenerateReturnOrder: false,
		numberOfPackages: 0,
		numberOfPallets: 0,
		orderType: undefined,
		originalDespatchParty: address(),
		originalShipper: address(),
		packages: [],
		poReference: undefined,
		registeredDate: createDateObject(),
		sendersReference: undefined,
		economicalStatus: statuses.economical.notSettled,
		status: statuses.order.draft,
		volume: 0,
		waybillNumber: undefined,
		vendor: undefined,
		external: false,
		tripId: null,
		tripNumber: null,
		isLoadingTrip: false,
		trip: null,
		events: []
	};
}

// function edi() {
// 	return { transmissions: [] };
// }

function address() {
	return {
		id: undefined,
		name: undefined,
		street: undefined,
		country: undefined,
		postalCode: undefined,
		countryCode: undefined,
		postalPlace: undefined,
		latitude: undefined,
		longitude: undefined,
		contactName: undefined,
		contactPhone: undefined,
		contactEmail: undefined
	};
}

export function emptyDate() {
	return {
		date: undefined,
		hasTime: false,
		timeZone: 'Europe/Oslo',
		epoch: undefined
	};
}
